import axios from 'axios';
import apiClient from '../apiClient';
import { URLEndpoints } from '../../constants/urlConstants';
const baseUrl=process.env.REACT_APP_NODEJS_SERVER_URL
export const getCustomerFiles=async(id)=>{
    try {
       const res= await apiClient.get(`${baseUrl}/files/${URLEndpoints.customers}/${id}/${URLEndpoints.file}`)
       return res
    } catch (error) {
    }
}

export const getCustomerFilesWithMeta = async ({
  customerId,
  tag,
  status,
  folder,
} = {}) => {
  if (!customerId) return [];
  try {
    const res = await apiClient.get(
      `${baseUrl}/files/${URLEndpoints.customers}/${customerId}/${URLEndpoints.file}`,
      {
        params: {
          includeMeta: true,
          ...(tag ? { tag } : {}),
          ...(status ? { status } : {}),
          ...(folder ? { folder } : {}),
        },
      }
    );
    return res?.data?.files || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

// services/customerFiles.js
export const uploadFile = async (id, payload) => {
  try {
    let body;

    // 1) If caller already passed FormData, use it as-is
    if (typeof FormData !== "undefined" && payload instanceof FormData) {
      body = payload;
    } else {
      // 2) Otherwise, accept { file, previewBlob, folder } and build FormData
      const { file, previewBlob, folder = "unfiled" } = payload || {};
      const fd = new FormData();
      if (file)        fd.append("file", file);
      if (previewBlob) fd.append("preview", previewBlob, "preview.png");
      fd.append("folder", folder);
      body = fd;
    }

    // IMPORTANT: let axios set the multipart boundary for FormData
    const res = await apiClient.post(
      `${baseUrl}/files/${URLEndpoints.customers}/${id}/files`,
      body
      // no need to set headers: axios detects FormData automatically
      // { headers: { "Content-Type": "multipart/form-data" } }
    );

    // Return the DB row the API sends back
    return res?.data?.file; // { id, filePath, previewUrl, ... }
  } catch (error) {
    // surface the error to the caller so they can toast/log
    throw error;
  }
};


export const uploadSupplierImage = async (file, folder = "supplier-images") => {
    const form = new FormData();
    form.append("file", file);
    form.append("folder", folder);
  
    return axios.post(`${baseUrl}/files/uploads/supplier-image`, form, {
      headers: {
        "Content-Type": "multipart/form-data",
        accessToken: localStorage.getItem("accessToken"),
      },
    });
  };

export const ensureCustomerFilePreviews = async (customerId, fileIds = []) => {
  if (!customerId) return [];
  const normalizedIds = [...new Set(
    (Array.isArray(fileIds) ? fileIds : [])
      .map((value) => Number(value))
      .filter((value) => Number.isFinite(value) && value > 0)
  )];
  if (!normalizedIds.length) return [];

  const response = await apiClient.post(
    `${baseUrl}/files/${URLEndpoints.customers}/${customerId}/files/previews/ensure`,
    { fileIds: normalizedIds }
  );

  return response?.data?.files || [];
};
